import DataReportBlock from '../../../reporter/report/DataReportBlock';
import { TransferRecord } from '../../../webrtc/agent/interfaces';
import { TrimmedTransferRecord } from '../../../reporter/report/Report';
import { ReportingContext } from '../../../config/ContentConfig';

export const filterTransfer = (
  transfer: TrimmedTransferRecord | TransferRecord,
  context: ReportingContext
): TrimmedTransferRecord | TransferRecord => {
  transfer.externalIp = getFirstOrUndef(context?.externalIps);
  transfer.internalIp = getFirstOrUndef(context?.internalIps);
  return transfer;
};

export const getFirstOrUndef = (obj?: string[]) => {
  return Array.isArray(obj) && obj.length > 0 ? obj[0] : undefined;
};

export default function filterTransfers(
  report: DataReportBlock<TrimmedTransferRecord | TransferRecord>,
  context: ReportingContext
): DataReportBlock<TrimmedTransferRecord | TransferRecord> {
  const data = report.data.map(d => filterTransfer(d, context));
  return new DataReportBlock({ data });
}
